// extracted by mini-css-extract-plugin
module.exports = {"body-text":"environments_body-text__7_QUs","content-wrapper":"environments_content-wrapper___1QfU","teaching":"environments_teaching__3bg9s"};